import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export interface ErrorCardExplicitCloseableData {
  message: string;
  detail?: unknown;
}

@Component({
    selector: 'app-error-card-explicit-closeable',
    templateUrl: './error-card-explicit-closeable.component.html',
    styleUrls: ['./error-card-explicit-closeable.component.scss'],
    standalone: false
})
export class ErrorCardExplicitCloseableComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<ErrorCardExplicitCloseableComponent>, @Inject(MAT_DIALOG_DATA) public data: ErrorCardExplicitCloseableData) { }

  ngOnInit() {
  }

  public closeMe() {
    this.dialogRef.close();
  }

}
